function isValidMeasurementId(value) {
  return typeof value === 'string' && /^G-[A-Z0-9]+$/i.test(value.trim());
}

function getMeasurementId() {
  const configuredId = window.CINETIKA_GA4_MEASUREMENT_ID;
  return typeof configuredId === 'string' ? configuredId.trim() : '';
}

function ensureGtagScript(measurementId) {
  const existingScript = document.querySelector('script[data-ga4-loader="true"]');
  if (existingScript) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  script.dataset.ga4Loader = 'true';
  document.head.appendChild(script);
}

function ensureGtagFunction() {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag === 'function') {
    return;
  }

  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
}

let initializedMeasurementId = null;

export function initAnalytics() {
  const measurementId = getMeasurementId();
  if (!isValidMeasurementId(measurementId)) {
    return false;
  }

  ensureGtagScript(measurementId);
  ensureGtagFunction();

  if (initializedMeasurementId === measurementId) {
    return true;
  }

  window.gtag('js', new Date());
  window.gtag('config', measurementId, {
    send_page_view: false,
  });

  initializedMeasurementId = measurementId;
  return true;
}

function buildPagePath(routeId) {
  const basePath = `${window.location.pathname}${window.location.search}`;
  if (!routeId || routeId === 'index') {
    return basePath || '/';
  }

  const hash = window.location.hash || `#/${routeId}`;
  return `${basePath}${hash}`;
}

function buildPageLocation(routeId) {
  if (!routeId || routeId === 'index') {
    return window.location.href.replace(/#\/index$/i, '');
  }

  return window.location.href;
}

export function trackPageView(routeId) {
  if (!initAnalytics()) {
    return false;
  }

  window.gtag('event', 'page_view', {
    page_title: document.title,
    page_location: buildPageLocation(routeId),
    page_path: buildPagePath(routeId),
  });

  return true;
}
